import {FormatterBasic} from "./Core/FormatterBasic";

export class SimpleTextFormatter extends FormatterBasic {
    Format(): string {
        return this.GetValue('Value');
    }

}